<!-- Confirm -->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- Context Menu -->
<p-contextMenu #cm [model]="contextMenu" [style]="{'width': 'auto'}"></p-contextMenu>

<!-- ui Canvas -->
<canvas hidden #emptyCanvas></canvas>

<!-- Message -->
<p-toast>
	<ng-template let-message pTemplate="message">
		<div class="p-grid p-ml-2">
			<div class="p-col-2">
				<i class="pi pi-exclamation-triangle" style="font-size: 2rem"></i>
			</div>
			<div class="p-col-10">
				<h4>{{message.summary}}</h4>
			</div>
			<div class="p-col-12">
				<p>{{message.detail}}</p>
			</div>
			<div *ngIf="message.severity!='success'" class="p-col-12">
				<a class="p-button"
					href="mailto:{{env_supportmail}}?subject=Fehlermeldung%20VION&amp;body={{message.summary}}%0A%0A{{message.detail}}%0D%0A%0D%0AName:%0D%0AEmail:%0D%0ATelefon:%0D%0AKommentar:%0D%0A%0D%0A%0D%0AZum%20besseren%20Verständnis%20wenn%20möglich%20bitte%20Screenshots%20beifügen.">
					Fehler melden
				</a>
			</div>
		</div>
	</ng-template>
</p-toast>

<p-toast key="refresh">
	<ng-template let-message pTemplate="message">
		<div class="p-grid p-ml-2">
			<div class="p-col-2">
				<i class="pi pi-exclamation-triangle" style="font-size: 2rem"></i>
			</div>
			<div class="p-col-10">
				<h4>{{message.summary}}</h4>
			</div>
			<div class="p-col-12">
				<p>{{message.detail}}</p>
			</div>
			<div class="p-col-12">
				<button *ngIf="accountService.checkPermissions(3, 0)" pButton pRipple
					label="{{'BUTTONS.REFRESH'|translate}}" (click)="read()"></button>
			</div>
		</div>
	</ng-template>
</p-toast>

<p-toast key="reset">
	<ng-template let-message pTemplate="message">
		<div class="p-grid p-ml-2">
			<div class="p-col-2">
				<i class="pi pi-exclamation-triangle" style="font-size: 2rem"></i>
			</div>
			<div class="p-col-10">
				<h4>{{message.summary}}</h4>
			</div>
			<div class="p-col-12">
				<p>{{message.detail}}</p>
			</div>
			<div class="p-col-12">
				<button *ngIf="accountService.checkPermissions(3, 0)" pButton pRipple
					label="{{'BUTTONS.RESET'|translate}}" (click)="table.clear()"></button>
			</div>
		</div>
	</ng-template>
</p-toast>

<!-- Spinner -->
<div *ngIf="loading !== 0" class="spinner">
	<span class="ball-1"></span>
	<span class="ball-2"></span>
	<span class="ball-3"></span>
	<span class="ball-4"></span>
	<span class="ball-5"></span>
	<span class="ball-6"></span>
	<span class="ball-7"></span>
	<span class="ball-8"></span>
</div>

<!-- Toolbar -->
<div class="card p-my-0">
	<p-toolbar>
		<div class="p-toolbar-group-left">
			<button *ngIf="updatePermission" type="button" pButton pRipple icon="fa fa-floppy-disk"
				class="p-button-success p-mr-2" pTooltip="{{'BUTTONS.SAVE' | translate }}" tooltipPosition="bottom"
				(click)="editEntry()"></button>
		</div>
		<h5 class="p-m-0">{{ name | translate }}</h5>
		<div class="p-toolbar-group-right">
			<button type="button" pButton
				[icon]="state.horizontalGroups ? 'fa fa-grip-vertical' : 'fa fa-grip-horizontal'"
				class="p-button-secondary p-mx-2"
				pTooltip="{{(state.horizontalGroups ? 'BUTTONS.VERTICAL_GROUPS' : 'BUTTONS.HORIZONTAL_GROUPS') | translate }}"
				tooltipPosition="bottom" (click)="setHorizontalGroups(!state.horizontalGroups)"></button>
		</div>
	</p-toolbar>
</div>

<!-- Content -->

<div class="p-grid p-formgrid">
	<div *ngIf="entry" id='edit' class="p-col-12">
		<div class="p-grid p-formgrid">
			<div *ngFor="let fields of fieldgroups"
				[ngClass]="state.horizontalGroups ? 'p-col-12  p-my-2' : ('p-col-12' + (fieldgroups.length > 1 ? ' p-md-6' : '') + (fieldgroups.length > 3 ? ' p-lg-3' : '') + ' p-my-2')">
				<div class="card" style="height:100%;">
					<div class="p-grid p-formgrid">
						<div *ngFor="let field of fields"
							 [ngClass]="state.horizontalGroups ? 'p-col-12 p-md-6 p-lg-3 p-my-2' : 'p-col-12 p-my-2'">
							<h6 class="p-my-2">
								{{ 'HEADERS.' + field.key | translate }}
							</h6>
							<div *ngIf="field.type == 'text'">
								<input type="text" pInputText [(ngModel)]="entry[field.key]" />
							</div>
							<div *ngIf="field.type == 'numeric'">
								<p-inputNumber [(ngModel)]="entry[field.key]" [showButtons]="true" [min]="0"
											   mode="decimal" locale="de-DE" [style]="{'width':'100%'}"></p-inputNumber>
							</div>
							<div *ngIf="field.type === 'dropdown'" class="p-inputgroup" [style.width]="'90%'"
								 [style.max-width]="'400px'">
								<p-dropdown class="dropdown-button-group" [style]="{'width':'100%'}"
											[options]="options[field.key]" [(ngModel)]="entry[field.key]" placeholder="-"
											[showClear]="true" [virtualScroll]="true" itemSize="30" [filter]="true"
											appendTo="body" dropdownDirective></p-dropdown>
							</div>
							<div *ngIf="field.type == 'boolean'">
								<p-inputSwitch [(ngModel)]="entry[field.key]"></p-inputSwitch>
							</div>
							<div *ngIf="field.type == 'date'">
								<p-calendar [showIcon]="true" [showTime]="true" [showSeconds]="true" hourFormat="24"
											dateFormat="dd/mm/yy" [(ngModel)]="entry[field.key]" [touchUI]="isMobile"
											appendTo="body"></p-calendar>
							</div>
							<div *ngIf="field.type == 'object'" [style.width]="'90%'" [style.max-width]="'400px'">
								<p-dropdown class="dropdown-button-group" [style]="{'width':'100%'}"
											[options]="options[field.key]" [(ngModel)]="entry[field.key]" placeholder="-"
											[showClear]="true" [virtualScroll]="true" itemSize="30" [filter]="true"
											appendTo="body" dropdownDirective>
									<ng-template pTemplate="header">
										<div class="p-inputgroup p-px-4 p-pt-3" (click)="$event.stopPropagation()">
											<p-dropdown #optionSortFieldSelection class="dropdown-button-group"
														[style]="{'width':'100%'}" [options]="field.optionSortFieldOptions"
														placeholder="-" [virtualScroll]="true" itemSize="30" [filter]="true"
														(onChange)="changeSorting(field);$event.originalEvent.stopPropagation();"
														[(ngModel)]="field.optionSortField" appendTo="body" dropdownDirective>
											</p-dropdown>
											<button type="button" pButton pRipple
													[icon]="field.sortDescending ? 'fa fa-arrow-down-wide-short' : 'fa fa-arrow-down-short-wide'"
													class="p-button-secondary p-ml-1"
													(click)="field.sortDescending = !field.sortDescending; changeSorting(field);"
													pTooltip="{{'BUTTONS.CHANGE_SORTING' | translate }}"
													tooltipPosition="bottom"></button>
										</div>
									</ng-template>
								</p-dropdown>
							</div>
							<div *ngIf="field.type == 'list'" class="p-inputgroup" [style.width]="'90%'"
								 [style.max-width]="'400px'">
								<p-multiSelect [style]="{'width':'100%'}" [options]="options[field.key]"
											   dataKey="ds_this_id" placeholder="-" (onChange)="updateRating(field.key)"
											   [(ngModel)]="entry[field.key]" [virtualScroll]="true" itemSize="30" appendTo="body"
											   (onPanelShow)="formatMultiselectLayout()" multiselectDirective>
									<ng-template pTemplate="header">
										<div class="p-inputgroup p-pb-2 p-pt-1 multiselectSort"
											 (click)="$event.stopPropagation()">
											<p-dropdown #optionSortFieldSelection class="dropdown-button-group"
														[style]="{'width':'100%'}" [options]="field.optionSortFieldOptions"
														placeholder="-" [virtualScroll]="true" itemSize="30" [filter]="true"
														(onChange)="changeSorting(field);$event.originalEvent.stopPropagation();"
														[(ngModel)]="field.optionSortField" appendTo="body" dropdownDirective>
											</p-dropdown>
											<button type="button" pButton pRipple
													[icon]="field.sortDescending ? 'fa fa-arrow-down-wide-short' : 'fa fa-arrow-down-short-wide'"
													class="p-button-secondary p-ml-1"
													(click)="field.sortDescending = !field.sortDescending; changeSorting(field);"
													pTooltip="{{'BUTTONS.CHANGE_SORTING' | translate }}"
													tooltipPosition="bottom"></button>
										</div>
									</ng-template>
								</p-multiSelect>
								<button type="button" pButton pRipple icon="fa fa-plus" class="p-button-success p-ml-2"
										(click)="createOption(field)" pTooltip="{{'BUTTONS.NEW' | translate }}"
										tooltipPosition="bottom"></button>
							</div>
							<div *ngIf="field.type === 'plz'">
								<p-inputMask [(ngModel)]="entry[field.key]" mask="99999" slotChar=""
											 (onComplete)="getPlacesFromPostalCode(field.key)">
								</p-inputMask>
							</div>
							<div *ngIf="field.type === 'village'" class="p-inputgroup" [style.width]="'90%'"
								 [style.max-width]="'400px'">
								<p-dropdown class="dropdown-button-group" [style]="{'width':'100%'}"
											[options]="placeNames[field.plz_field]" placeholder="-" [showClear]="true"
											[virtualScroll]="true" itemSize="30" [filter]="true" editable="true"
											[(ngModel)]="entry[field.key]" appendTo="body" dropdownDirective>
								</p-dropdown>
							</div>
							<div *ngIf="field.type === 'rating'" class="p-formgroup-inline">
								<div class="p-m-1">
									<p-dropdown [options]="options[field.key]" [(ngModel)]="entry[field.key]"
												[showClear]="true" dropdownDirective>
										<ng-template let-option pTemplate="selectedItem">
											<i [ngClass]="option.value === 0 ? 'pi pi-circle-off' : 'pi pi-circle-on'"
											   [style.color]="option.icon"></i>
										</ng-template>
										<ng-template let-option pTemplate="item">
											<i [ngClass]="option.value === 0 ? 'pi pi-circle-off' : 'pi pi-circle-on'"
											   [style.color]="option.icon"></i>
										</ng-template>
									</p-dropdown>
								</div>
								<div class="p-my-1 p-mx-2">
									Errechnete<br>
									Bewertung
								</div>
								<div class="p-my-3">
									<i [ngClass]="rating === 0 ? 'pi pi-circle-off' : 'pi pi-circle-on'"
									   [style.color]="ratings[rating]"></i>
								</div>
							</div>
							<small *ngIf="field.required && (entry[field.key] == null || entry[field.key] === '')"
								   class="p-error block" translate>REQUIRED</small>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12">
		<div class="card p-my-2" style="min-height: 100%">
			<div class="p-grid p-formgrid">
				<div *ngIf="entry && entry['FREMD_aufzeichnung_video_url']" class="p-m-2 p-p-0">
					<video id="videoAkteEditRef" (timeupdate)="setVehiclePosition($event.target.currentTime)"
						(loadedmetadata)="initGPX($event)" controls [src]="videoSafeUrl">
					</video>
				</div>
				<div id="mapAkteEditRefAufzeichnung" class="p-m-2 p-p-0" style="width: 720px; height: 575px;"></div>
			</div>
			<p-table #table (onColResize)="onColResize($event)" (onColReorder)="onColReorder($event)"
				(onFilter)="onFilter($event)"
				(onRowSelect)="isMobile && cm.show($event.originalEvent); $event.originalEvent.stopPropagation();"
				[(contextMenuSelection)]="selectedEntry" [(selection)]="selectedEntry" [contextMenu]="cm"
				[globalFilterFields]="filters" [reorderableColumns]="true" [resizableColumns]="true"
				[scrollHeight]="contentHeight + 'px'" [virtualRowHeight]="45" [virtualScroll]="true"
				columnResizeMode="expand" dataKey="ds_auto_id" scrollDirection="both" selectionMode="single"
				sortField="ankey" [stateKey]="tableStateName" stateStorage="local" styleClass="p-datatable-gridlines"
				[columns]="cols" [rows]="100" [scrollable]="true" [value]="entries">
				<ng-template pTemplate="caption">
					<div class="p-d-flex p-ai-center p-jc-between">
						<div>
							<button type="button" pButton icon="pi pi-file-o" (click)="table.exportCSV()"
								class="p-my-2 p-mx-1" pTooltip="CSV" tooltipPosition="bottom"></button>
							<button type="button" pButton icon="pi pi-file-excel" (click)="exportXLSX()"
								class="p-button-success p-my-2 p-mx-1" pTooltip="XLS" tooltipPosition="bottom"></button>
							<button type="button" pButton icon="pi pi-file-pdf" (click)="exportPDF()"
								class="p-button-warning p-my-2 p-mx-1" pTooltip="PDF" tooltipPosition="bottom"></button>
						</div>
						<h5 class="p-m-0">{{ 'HEADERS.AUFZEICHNUNG' | translate }}</h5>
						<span class="p-input-icon-left">
							<i class="pi pi-search"></i>
							<input pInputText id="global" type="text" [value]="globalFilter"
								(input)="table.filterGlobal($event.target.value, 'contains');globalFilter = $event.target.value;"
								placeholder="{{'BUTTONS.SEARCH'|translate}}" />
						</span>
					</div>
				</ng-template>
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th *ngFor="let col of columns" [style.flex]="'0 0 ' + col.width + 'px !important'"
							[pSortableColumn]="col.key" pResizableColumn pReorderableColumn>
							<div class="p-d-flex p-ai-center p-jc-between" style="min-width: 100%">
								<div>
									<p-sortIcon [field]="col.key"></p-sortIcon>
									{{ 'HEADERS.' + col.key | translate }}
								</div>
								<p-columnFilter [type]="col.type" [field]="col.key" display="menu" appendTo="body"
									[style.color]="(isColFiltered(col) ? 'var(--primary-color)' : 'var(--text-color)')">
								</p-columnFilter>
							</div>
						</th>
						<th id="buttoncolhead" [style.flex]="'0 0 ' + buttonColWidth + 'px'" alignFrozen="right"
							pFrozenColumn>
							<p-multiSelect #colselection [options]="possibleCols" [(ngModel)]="cols" dataKey="key"
								(onChange)="toggleColumn($event)" optionLabel="label" appendTo="body"
								[style.visibility]="'hidden'" [style.position]="'absolute'"
								[panelStyle]="{'min-width':'auto'}" class="colselect">
							</p-multiSelect>
							<button pButton pRipple icon="fas fa-table-columns"
								class="p-button-rounded p-button-secondary p-mr-2"
								(click)="colselection.show($event.originalEvent);"
								pTooltip="{{'BUTTONS.COL_SELECT'|translate}}" tooltipPosition="bottom"
								showDelay="500"></button>
							<button pButton pRipple icon="pi pi-filter-slash"
								class="p-button-rounded p-button-secondary p-mr-2" (click)="table.clear()"
								pTooltip="{{'BUTTONS.RESET_FILTERS'|translate}}" tooltipPosition="bottom"
								showDelay="500"></button>
							<button pButton pRipple icon="fas fa-table-cells"
								class="p-button-rounded p-button-secondary p-mr-2" (click)="resetTable()"
								pTooltip="{{'BUTTONS.RESET_TABLE'|translate}}" tooltipPosition="bottom"
								showDelay="500"></button>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-entry let-rowIndex="rowIndex" let-columns="columns">
					<tr style="height:45px" [pContextMenuRow]="entry" [pSelectableRow]="entry">
						<td *ngFor="let col of columns" [style.flex]="'0 0 ' + col.width + 'px !important'">
							<div *ngIf="entry[col.key] === null">
								<i class="pi pi-minus"></i>
							</div>
							<div *ngIf="entry[col.key] !== null">
								<div *ngIf="col.type == 'text'">
									{{ entry[col.key] }}
								</div>
								<div *ngIf="col.type == 'numeric'">
									{{ entry[col.key] }}
								</div>
								<div *ngIf="col.type == 'boolean'">
									<i [ngClass]="entry[col.key] ? 'pi pi-check' : 'pi pi-times'"
										[style.color]="entry[col.key] ? 'green' : 'red'"></i>
								</div>
								<div *ngIf="col.type == 'date'">
									{{ parseDate(entry[col.key]) }}
								</div>
							</div>
						</td>
						<td class="buttoncolbody" [style.flex]="'0 0 ' + buttonColWidth + 'px'" alignFrozen="right"
							pFrozenColumn>
							<a id="detailbutton"
								[routerLink]="url_aufzeichnung + '/' + url_detail + '/' + entry.ds_this_id"
								class="p-button-rounded p-button-success p-mr-2 p-ripple p-button p-component p-button-icon-only">
								<i class="pi pi-search"></i>
							</a>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="summary">
					<div class="p-d-flex p-ai-center p-jc-between">
						{{ 'TABLE.COUNT' | translate : { count : count } }}
						{{ (table && table.filteredValue ? 'TABLE.TOTAL' : '') | translate : { count : (entries ?
						entries.length
						: 0) } }}
						<div>
							{{ 'TABLE.LAST_REFRESH' | translate }}: {{ loadTimestamp ?
							loadTimestamp.toLocaleString() : '' }}
						</div>
					</div>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>